export default __webpack_public_path__ + "static/media/aranciaTtsIt_It60.61c8fe27.mp3";